import React from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function FiltersRow({
  columns = [],
  sx = {},
  dense = true,
}) {
  return (
    <Paper
    elevation={0}
    sx={{
        borderRadius: "12px",
        border: "1px solid rgba(145, 158, 171, 0.2)",
        overflow: "visible",
        position: "relative", 
        zIndex: 1,
        ...sx,
    }}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          background: "#f4f6f8",
          
        }}
      >
        {columns.map((col, idx) => {
          const isLast = idx === columns.length - 1;

          return (
            <Box
              key={col.key || idx}
              sx={{
                position: "relative",
                zIndex: 0,
                flex: col.width ? "0 0 auto" : "1 1 0",
                width: col.width || "auto",
                minWidth: col.minWidth || 140,
                padding: dense ? "10px 12px" : "14px 16px",
                borderRight: isLast
                  ? "none"
                  : "1px solid rgba(145, 158, 171, 0.2)",
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  color: "rgb(33, 43, 54)",
                  fontWeight: 600,
                  marginBottom: "6px",
                }}
              >
                {col.label}
              </Typography>

              {/* control */}
                <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    height: 34,
                    minHeight: 34,
                    width: "100%",
                    overflow: "visible",  
                    position: "relative", 
                    zIndex: 10, 
                }}
                >
                {col.control}
                </Box>

            </Box>
          );
        })}
      </Box>
    </Paper>
  );
}
